import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { isPrerender } from "@faire/web--source/common/user-agent/isPrerender";
import { Column } from "@faire/web--source/slate/Layout";
import { Typography } from "@faire/web--source/slate/Typography";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackLoggedOutRetailersLoggedOutHomeRedesignCtaClick } from "@faire/web-api--source/events/loggedOutRetailers/click/loggedOutHomeRedesignCta";
import { trackLoggedOutRetailersLoggedOutHomeRedesignView } from "@faire/web-api--source/events/loggedOutRetailers/view/loggedOutHomeRedesign";
import classNames from "classnames";
import React from "react";
import { setTimeoutIfPossible } from "@faire/retailer-visitor-shared/lib/async-functions/setTimeoutIfPossible";
import { handleKeyDown } from "@faire/retailer-visitor-shared/lib/handleKeyDown";
import { useSettingLoggedOutHomepageRedesignV2 } from "@faire/retailer/settings/useSettingLoggedOutHomepageRedesignV2";
import * as animatedStyles from "@faire/retailer/views/home/logged-out-homepage/__internal__/components/__internal__/Animation/animation.css";
import { useAnimatedScroll } from "@faire/retailer/views/home/logged-out-homepage/__internal__/components/__internal__/Animation/useAnimatedScroll";
import { invisible } from "@faire/retailer/views/home/logged-out-homepage/__internal__/components/__internal__/Prerender/style.css";
import * as tabStyles from "@faire/retailer/views/home/logged-out-homepage/__internal__/components/__internal__/Tabs/tabs.css";
import { BrandValueBannerBrandInfo } from "@faire/retailer/views/home/logged-out-homepage/__internal__/components/BrandValueBanner/__internal__/BrandValueBannerBrandInfo";
import { useGetBrandValues } from "@faire/retailer/views/home/logged-out-homepage/__internal__/components/BrandValueBanner/__internal__/useGetBrandValues";
import * as componentStyles from "@faire/retailer/views/home/logged-out-homepage/__internal__/components/BrandValueBanner/styles.css";
export var BrandValueBanner = function() {
    var _getBrandValues_currentIndex;
    var getBrandValues = useGetBrandValues();
    var homepageRedesignVariant = useSettingLoggedOutHomepageRedesignV2();
    var ref = useDoActionWhenVisible(function() {
        return trackLoggedOutRetailersLoggedOutHomeRedesignView("brand_value_banner", "".concat(homepageRedesignVariant));
    });
    var _getBrandValues_length;
    var _useAnimatedScroll = useAnimatedScroll((_getBrandValues_length = getBrandValues === null || getBrandValues === void 0 ? void 0 : getBrandValues.length) !== null && _getBrandValues_length !== void 0 ? _getBrandValues_length : 0, 5000), resumeScroll = _useAnimatedScroll.resumeScroll, pauseScroll = _useAnimatedScroll.pauseScroll, isVisible = _useAnimatedScroll.isVisible, currentIndex = _useAnimatedScroll.currentIndex, setCurrentIndex = _useAnimatedScroll.setCurrentIndex;
    var handleClickTab = function(index, brandValue) {
        pauseScroll();
        setCurrentIndex(index);
        trackLoggedOutRetailersLoggedOutHomeRedesignCtaClick("brand_value_banner-tab", brandValue, "".concat(homepageRedesignVariant));
        setTimeoutIfPossible(function() {
            resumeScroll();
        }, 12000);
    };
    return /*#__PURE__*/ _jsxs(Column, {
        gap: "2x",
        className: classNames(componentStyles.wrapper, animatedStyles.animatedContainerParent),
        ref: ref,
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: {
                    mobileAndAbove: "displaySSerifRegular",
                    desktopAndAbove: "displayMSerifRegular"
                },
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "GeVLCg",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Shop by the values you care most about"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: tabStyles.tabBar,
                style: {
                    maxWidth: "866px"
                },
                children: getBrandValues.map(function(brandValue, index) {
                    return /*#__PURE__*/ _jsx(Typography, {
                        tabIndex: 0,
                        "data-is-selected": index === currentIndex,
                        className: tabStyles.tab,
                        onClick: function() {
                            return handleClickTab(index, brandValue.id);
                        },
                        onKeyDown: handleKeyDown(function() {
                            return handleClickTab(index, brandValue.id);
                        }),
                        children: brandValue.name
                    }, index);
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                style: {
                    overflow: "hidden"
                },
                onMouseEnter: pauseScroll,
                onMouseLeave: resumeScroll,
                className: classNames(animatedStyles.animatedContainer, animatedStyles.animatedContainerParent),
                "data-is-visible": isVisible,
                children: isPrerender() ? /*#__PURE__*/ _jsx(_Fragment, {
                    children: getBrandValues.map(function(brandValue, index) {
                        return /*#__PURE__*/ _jsx(BrandValueBannerBrandInfo, {
                            brandInfo: brandValue.brand,
                            className: index ? invisible : ""
                        }, index);
                    })
                }) : /*#__PURE__*/ _jsx(BrandValueBannerBrandInfo, {
                    brandInfo: (_getBrandValues_currentIndex = getBrandValues[currentIndex]) === null || _getBrandValues_currentIndex === void 0 ? void 0 : _getBrandValues_currentIndex.brand
                })
            })
        ]
    });
};
